import { lexonHttp } from '@/plugins/axios/lexonHttp'
import {
  ExecuteImportResponse,
  FileStreamResponse,
  IMPORT_EXPEDIENT_FILE_MIME,
  ResponseFile,
  UploadImportFileResponse
} from '@/views/Expedients/components/ImportExpedientsDialog/types/ImportExpedientsDialogTypes'
import { AxiosResponse } from 'axios'
import { LexonApiCodeCatalog } from '@/types/LexonApiCodeCatalog'

export const executeImport = async (importId: string): Promise<ExecuteImportResponse> => {
  try {
    const response = await lexonHttp.post(`/v2/expedients/import/execute/${ importId }`)
    if (response.data?.importId
      && response.data?.successCount
      && response.data?.failureCount
      && response.data?.totalCount
    ) {
      return {
        success: true,
        importId: response.data.importId,
        successCount: response.data.successCount,
        failureCount: response.data.failureCount,
        totalCount: response.data.totalCount
      }
    } else {
      console.log(`Respuesta inválida: status ${ response.status }, importId: ${ response.data }`)
      return {
        success: false
      }
    }
  } catch (error) {
    console.log('Respuesta error', { error })
    return {
      success: false
    }
  }
}

export const downloadTemplate = async (): Promise<ResponseFile> => {
  const response = await lexonHttp.get(
    '/v2/expedients/import/template',
    { responseType: 'blob' }
  )

  return createFileForDownload(response)
}

export const downloadFailures = async (importId: string): Promise<ResponseFile> => {
  const response = await lexonHttp.get(
    `/v2/expedients/import/failures/${ importId }`,
    { responseType: 'blob' }
  )

  return createFileForDownload(response)
}

export const deleteImportFile = async (importId: string) => {
  try {
    await lexonHttp.delete(`/v2/expedients/import/file/${ importId }`)
  } catch (error) {
    console.log(error)
  }
}

export const uploadImportFile = async (file: File): Promise<UploadImportFileResponse> => {
  const formData = new FormData()
  formData.append('importFile', file)
  try {
    const response = await lexonHttp.post(
      '/v2/expedients/import/file',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )

    return response.data?.importId
      ? { importId: response.data.importId, success: true }
      : { success: false }
  } catch (error) {
    console.log('Not success import', { error })
    return {
      success: false,
      emptyContentError: LexonApiCodeCatalog.NO_CONTENT_FILE === error?.response?.data?.exceptionCode
    }
  }
}

function extractFilenameFromHeaders(headers?: Record<string, string>): string | null {
  if (!headers) {
    return null
  }

  const contentDisposition = headers['content-disposition'] || headers['Content-Disposition']
  if (!contentDisposition) {
    return null
  }

  const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].replace(/['"]/g, '')
  }

  return null
}

function toFileStreamResponse(response: AxiosResponse<Blob | ArrayBuffer | any>): FileStreamResponse {
  return {
    data: response.data,
    headers: response.headers as Record<string, string>,
    status: response.status
  }
}

function createFileForDownload(response: AxiosResponse<Blob | ArrayBuffer | any>): ResponseFile {
  const fileStreamResponse: FileStreamResponse = toFileStreamResponse(response)
  if (!fileStreamResponse.data) {
    throw new Error('Los datos de respuesta están vacíos o no son válidos para crear un archivo')
  }
  if (fileStreamResponse.status < 200 || fileStreamResponse.status >= 300) {
    throw new Error(`Error en la respuesta del servidor: status ${ fileStreamResponse.status }`)
  }
  const filename = extractFilenameFromHeaders(fileStreamResponse.headers)
  console.log(filename ? `Archivo descargado: ${ filename }` : 'Descargando archivo sin nombre específico')
  const blob = new Blob([fileStreamResponse.data], {
    type: IMPORT_EXPEDIENT_FILE_MIME
  })
  if (blob.size === 0) {
    console.warn('El archivo descargado tiene tamaño 0, puede que no haya datos válidos')
  }

  return {
    downloadUrl: URL.createObjectURL(blob)
  } as ResponseFile
}

